import { CrownFireType } from '@enums/CrownFireType'
import { MeteoConditionsID } from '@enums/MeteoConditionsID'
import { SimulationStatus } from '@enums/SimulationStatus'
import { MeteoConditionsDTO } from '@models/api/MeteoConditionsDTO'
import { SimulationDTO } from '@models/api/simulation/SimulationDTO'
import { Hours } from 'src/typings/time'

export const simulationMock: SimulationDTO = {
  ID_SIMULATION: 'FCA01153-CB86-4C78-B631-C13279992543',
  GEOMETRY: [[[42.348974, -3.070113]]],
  GEOMETRY_TYPE: [0],
  CREATION_TIME: '2023-01-26T07:38:39.417Z',
  INIT_TIME: '2023-07-26T06:00:00.000Z',
  END_TIME: '2023-07-26T18:00:00.000Z',
  HOURS_NUM: 12,
  INTERVAL: 60,
  CUSTOM_METEO: false,
  METEO: [],
  USE_WINDNINJA: false,
  USE_FIREWALL: false,
  FIREWALL: null,
  FIREWALL_TYPE: [],
  NAME: 'Usuario - 26-01-2023 08:38',
  FUEL_MODEL_AREA: null,
  FUEL_MODEL: null,
  OBSERVATION: '',
  STATUS: SimulationStatus.NEW,
  ID_USUARIO: 2,
  FUEL_MOISTURES_CONFIG: [
    {
      FLH: 0,
      FLW: 0,
      humidity: 6,
      humidity10h: 7,
      humidity100h: 9,
      model: 1
    }
  ],
  INPUT_FMD: [
    {
      FUEL_MODEL_TYPE: 1,
      H1: 0,
      H10: 0,
      H100: 0,
      LIVE_H: 0,
      LIVE_W: 0
    }
  ],
  CROWN_FIRE_FINNEY: CrownFireType.FINNEY,
  CROWN_FLAG: false,
  FOLIAR_MOISTURE: 0
}

export function getMeteoMock(hoursDuration: Hours): MeteoConditionsDTO[] {
  const totalHours = hoursDuration + 2
  return [
    {
      ID: MeteoConditionsID.TEMPERATURE,
      VARIABLE: 'temperatura',
      VALORES: Array(totalHours).fill(25),
      DECIMALES: 0
    },
    {
      ID: MeteoConditionsID.RELATIVE_HUMIDITY,
      VARIABLE: 'humedad',
      VALORES: Array(totalHours).fill(20),
      DECIMALES: 0
    },
    {
      ID: MeteoConditionsID.CLOUDINESS,
      VARIABLE: 'nubosidad',
      VALORES: Array(totalHours).fill(0),
      DECIMALES: 0
    },
    {
      ID: MeteoConditionsID.WIND_SPEED,
      VARIABLE: 'viento',
      VALORES: Array(totalHours).fill(0),
      DECIMALES: 0
    },
    {
      ID: MeteoConditionsID.WIND_DIRECTION,
      VARIABLE: 'direccionViento',
      VALORES: Array(totalHours).fill(0),
      DECIMALES: 0
    },
    {
      ID: MeteoConditionsID.PRECIPITATION,
      VARIABLE: 'precipitacion',
      VALORES: Array(totalHours).fill(0),
      DECIMALES: 0
    }
  ]
}
